export enum BulletColor {
  BLUE = 'BLUE',
  GREY = 'GREY',
  ORANGE = 'ORANGE',
  RED = 'RED'
}
